import { AnimatePresence, motion } from 'framer-motion';
import PropTypes from 'prop-types';
import r from 'render-dom';
import styled from 'styled-components';

import WidgetGridSkeleton from 'components/shared/WidgetGridSkeleton';
import { smallMax } from 'constants/mediaQueries';

const propTypes = {
    title: PropTypes.string.isRequired
};

const Card = styled(motion.div)`
    align-items: center;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: rgba(64, 64, 64, 0.52) 0px 0px 30px 0px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin: 10px 0;
    max-height: 100vh;
    max-width: 100%;
    min-width: 50vw;
    overflow: auto;
    padding: 30px 40px;
    position: relative;
    z-index: 2;

    @media(${smallMax}) {
        padding: 21px;
        width: 98vw;
    }
`;

const Center = styled(motion.div)`
    height: 100vh;
    left: 0;
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
`;

const Container = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
    height: 100%;
    padding: 0 !important;
    z-index: 4;
`;

const Shadow = styled(motion.div)`
    background-color: rgba(0, 0, 0, 0.8);
    height: 101vh;
    justify-content: center;
    left: 0;
    position: fixed;
    top: -1px;
    width: 100%;
    z-index: 1;
`;

const Title = styled.div`
    font-size: 32px;
    font-weight: 700;
    width: 100%;
`;

export default function OverlayCard({
    children,
    className = '',
    onClose,
    show = true,
    showSkeleton = true,
    title,
}) {
    const cardVariants = {
        hide: {
            opacity: 0,
            scale: 0.8,
            transition: { duration: 0.2 },
        },
        show: {
            opacity: 1,
            scale: 1,
            transition: { duration: 0.2 },
        },
    };
    const variants = {
        hide: {
            opacity: 0,
            transition: { duration: 0.2 },
        },
        show: {
            opacity: 1,
            transition: { duration: 0.2 },
        },
    };

    return (
        r(AnimatePresence, [
            r(Center, {
                animate: show ? 'show' : 'hide',
                exit: 'hide',
                initial: 'hide',
                isRendered: show,
            }, [
                r(Shadow, { onClick: onClose, show, variants }),
                r(WidgetGridSkeleton, { isRendered: showSkeleton }),
                r(Container, [
                    r(Card, { className, variants: cardVariants }, [
                        r(Title, [title]),
                        children,
                    ]),
                ]),
            ]),
        ])
    );
}

OverlayCard.prototype = propTypes;
